"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var user_service_1 = require("./user.service");
var advertisement_service_1 = require("./advertisement.service");
var error_sheet_component_1 = require("../Messages/error-sheet/error-sheet.component");
var material_1 = require("@angular/material");
var information_sheet_component_1 = require("../Messages/information-sheet/information-sheet.component");
var warning_sheet_component_1 = require("../Messages/warning-sheet/warning-sheet.component");
var router_1 = require("@angular/router");
var dialog_login_component_1 = require("../Dialogs/dialog.login/dialog.login.component");
var enter_dialog_component_1 = require("../Dialogs/enter-dialog/enter-dialog.component");
var Logger_1 = require("../Logger/Logger");
var AuthHeaders_1 = require("../api/AuthHeaders");
var thx_dialog_component_1 = require("../Dialogs/thx-dialog/thx-dialog.component");
var thx_logout_dialog_component_1 = require("../Dialogs/thx-logout-dialog/thx-logout-dialog.component");
var rxjs_1 = require("rxjs");
var captcha_service_1 = require("./captcha.service");
var ngx_cookie_service_1 = require("ngx-cookie-service");
var compare_versions_component_1 = require("../Cms/compare-versions/compare-versions.component");
var emoji_service_1 = require("./emoji.service");
var confirmation_sheet_component_1 = require("../Messages/confirm-sheet/confirmation-sheet.component");
var rxjs_2 = require("rxjs");
var i0 = require("@angular/core");
var i1 = require("./emoji.service");
var i2 = require("./captcha.service");
var i3 = require("./user.service");
var i4 = require("ngx-cookie-service");
var i5 = require("./advertisement.service");
var i6 = require("@angular/material/bottom-sheet");
var i7 = require("@angular/material/dialog");
var i8 = require("@angular/router");
var MainService = /** @class */ (function () {
    function MainService(emojiService, captchaService, userService, cookieService, advService, bottomSheet, dialog, route) {
        this.emojiService = emojiService;
        this.captchaService = captchaService;
        this.userService = userService;
        this.cookieService = cookieService;
        this.advService = advService;
        this.bottomSheet = bottomSheet;
        this.dialog = dialog;
        this.route = route;
        //app extra settings
        this.enableSubscription = false;
        this.enableCompareVersion = false;
        this.enableLetOurPros = false;
        this.enableAdvertiseWithUs = false;
        this.enablePhoneRegConfirm = false;
        this._disclaimerIsReady = false;
        this._aplicationIsReady = false;
        this.showStartVideo = true;
        this._progressCounter = 0;
        this._citiesFinished = false;
        this._over18Key = "Over18Years";
        this._isOver18 = false;
        this.over18Change = new rxjs_1.Subject();
        this.changeSearchData = new rxjs_1.Subject();
        this.EnterDialogShown = false;
        this._pageName = "";
        this.userService.services = this;
        this.advService.services = this;
        this.captchaService.obtainCaptchaSiteKeyFromServer();
        this.route.onSameUrlNavigation = "reload";
        this.observablePageName = new rxjs_2.BehaviorSubject(this._pageName);
    }
    Object.defineProperty(MainService.prototype, "disclaimerIsReady", {
        get: function () {
            return this._disclaimerIsReady;
        },
        set: function (val) {
            this._disclaimerIsReady = val;
            this.hideLoader();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainService.prototype, "aplicationIsReady", {
        get: function () {
            return this._aplicationIsReady;
        },
        set: function (val) {
            this._aplicationIsReady = val;
            this.hideLoader();
        },
        enumerable: true,
        configurable: true
    });
    MainService.prototype.hideLoader = function (force) {
        if (force === void 0) { force = false; }
        if (this.disclaimerIsReady && this.aplicationIsReady || force) {
            document.body.classList.remove("js-loader-active");
            var loaderBody = document.getElementById("loader_body");
            if (loaderBody)
                loaderBody.classList.add("hidden");
        }
    };
    MainService.prototype.showLoader = function () {
        document.body.classList.add("js-loader-active");
        var loaderBody = document.getElementById("loader_body");
        if (loaderBody)
            loaderBody.classList.remove("hidden");
    };
    Object.defineProperty(MainService.prototype, "citiesFinished", {
        get: function () {
            return this._citiesFinished;
        },
        set: function (value) {
            this._citiesFinished = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainService.prototype, "progress", {
        get: function () {
            return this._progressCounter > 0;
        },
        set: function (value) {
            if (value) {
                this._progressCounter++;
            }
            else {
                this._progressCounter--;
            }
            this._progressCounter = this._progressCounter < 0 ? 0 : this._progressCounter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainService.prototype, "Over18Years", {
        get: function () {
            if (this.userService.isAuthenticated()) {
                return true;
            }
            if (this._isOver18) {
                return true;
            }
            if (!this.cookieService.check(this._over18Key)) {
                return false;
            }
            return this.cookieService.get(this._over18Key) === 'true';
            //if (!sessionStorage.getItem(this._over18Key)) {
            //    return false;
            //}
            //return sessionStorage.getItem(this._over18Key) === "true";
        },
        set: function (v) {
            this.over18Change.next(v);
            this._isOver18 = v;
            this.cookieService.set(this._over18Key, v.toString(), 365);
            //sessionStorage.setItem(this._over18Key, v.toString());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainService.prototype, "selectedSearchParams", {
        get: function () {
            return this._selectedSearchParams.value;
        },
        set: function (formParams) {
            this._selectedSearchParams = formParams;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainService.prototype, "pageName", {
        get: function () {
            return this._pageName;
        },
        set: function (name) {
            this._pageName = name;
            this.observablePageName.next(name);
        },
        enumerable: true,
        configurable: true
    });
    MainService.prototype.showError = function (message) {
        return this.bottomSheet.open(error_sheet_component_1.ErrorSheetComponent, {
            data: { message: message }
        });
    };
    MainService.prototype.showInformation = function (message) {
        return this.bottomSheet.open(information_sheet_component_1.InformationSheetComponent, {
            data: { message: message }
        });
    };
    MainService.prototype.showWarning = function (message) {
        return this.bottomSheet.open(warning_sheet_component_1.WarningSheetComponent, {
            data: { message: message }
        });
    };
    MainService.prototype.showDialog = function (componentOrTemplateRef, config) {
        var _this = this;
        return new Promise(function (rs, rj) {
            var dialogRef = _this.dialog.open(componentOrTemplateRef, config);
            dialogRef.afterClosed().subscribe(function (result) {
                if (result) {
                    rs(result);
                }
                else {
                    rj();
                }
            });
        });
    };
    MainService.prototype.handleShowUpgradeToPremium = function () {
        if (!this.cookieService.check("logging_count")) {
            this.cookieService.set("logging_count", "1");
        }
        else {
            var loggingCount = parseInt(this.cookieService.get("logging_count"));
            if (loggingCount % 3 == 0 && !this.userService.isDemo() && !this.userService.isPremium() && !this.userService.isAdmin()) {
                var item = this.dialog.open(compare_versions_component_1.CompareVersionsComponent, {
                    width: "80%",
                    height: "762px",
                    panelClass: "CompareVersionsComponent-panel",
                    data: {
                        isPopup: true
                    }
                });
                item.componentInstance.isPopup = true;
            }
            this.cookieService.set("logging_count", (loggingCount + 1).toString());
        }
    };
    MainService.prototype.showConfirm = function (messageString, width) {
        var _this = this;
        if (messageString === void 0) { messageString = undefined; }
        if (width === void 0) { width = undefined; }
        if (!messageString) {
            messageString = "Are you sure?";
        }
        return new Promise(function (rs, rj) {
            var dialogRef = _this.dialog.open(confirmation_sheet_component_1.ConfirmationSheetComponent, {
                width: !width ? "40%" : width,
                data: { message: messageString }
            });
            dialogRef.afterClosed().subscribe(function (res) {
                rs(res);
            });
        });
    };
    MainService.prototype.showLogin = function (url, additionalLoginTitle) {
        var _this = this;
        if (url === void 0) { url = undefined; }
        if (additionalLoginTitle === void 0) { additionalLoginTitle = undefined; }
        if (this.userService.isAuthenticated()) {
            return;
        }
        else {
            var dialogRef = this.dialog.open(dialog_login_component_1.DialogLoginComponent, {
                width: "400px",
                data: {
                    additionalLoginTitle: additionalLoginTitle,
                    email: localStorage.getItem("email"),
                    password: "",
                    rememberme: true,
                    url: url
                }
            });
            dialogRef.afterClosed().subscribe(function (result) {
                if (result && result != "") {
                    _this.userService
                        .login(result.email, result.password, result.rememberme, url)
                        .then(function (r) {
                        _this.handleShowUpgradeToPremium();
                        if (_this.route.url == "/register") {
                            if (url)
                                _this.route.navigate(["main"]);
                        }
                        else {
                            if (url)
                                _this.route.navigate([url]);
                        }
                        _this.advService.searchDataUserAdv.currentSearchRule.userId = _this.userService.getUserId();
                        _this.advService.searchActionForUser();
                    })
                        .catch(function (e) {
                        _this.showError(e)
                            .afterDismissed()
                            .subscribe(function () {
                            _this.showLogin(url);
                        });
                    });
                }
            });
        }
    };
    MainService.prototype.showEnterDialog = function (url) {
        if (url === void 0) { url = undefined; }
        if (this.userService.isAuthenticated() || this.EnterDialogShown) {
            return;
        }
        else {
            this.EnterDialogShown = true;
            this.enterDialogRef = this.dialog.open(enter_dialog_component_1.EnterDialogComponent, {
                autoFocus: true,
                closeOnNavigation: false,
                disableClose: true,
                hasBackdrop: true,
                backdropClass: "enter-backdrop",
                data: {}
            });
            this.enterDialogRef.afterClosed().subscribe(function (result) {
                if (result == false) {
                    window.location.href = "http://google.com";
                }
            });
        }
    };
    MainService.prototype.showThxLogoutDialog = function (url) {
        if (url === void 0) { url = undefined; }
        var dialogRef = this.dialog.open(thx_logout_dialog_component_1.ThxLogoutDialogComponent, {
            autoFocus: true,
            hasBackdrop: true,
            disableClose: true,
            //backdropClass: "thx-backdrop", // cdk-overlay-dark-backdrop
            data: {}
        });
    };
    MainService.prototype.showThxDialog = function (url) {
        var _this = this;
        if (url === void 0) { url = undefined; }
        var dialogRef = this.dialog.open(thx_dialog_component_1.ThxDialogComponent, {
            autoFocus: true,
            //  closeOnNavigation: false,
            // disableClose: true,
            hasBackdrop: true,
            backdropClass: "thx-backdrop",
            data: {}
        });
        dialogRef.afterClosed().subscribe(function (result) {
            if (url != "") {
                _this.route.navigate([url]);
            }
            else {
                _this.route.navigate([""]);
            }
        });
    };
    MainService.prototype.getGoogleApiKey = function () {
        return AuthHeaders_1.getUserTokenFieldSchema("userdata");
    };
    MainService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MainService_Factory() { return new MainService(i0.ɵɵinject(i1.CustomEmojiService), i0.ɵɵinject(i2.CaptchaService), i0.ɵɵinject(i3.UserService), i0.ɵɵinject(i4.CookieService), i0.ɵɵinject(i5.AdvertisementService), i0.ɵɵinject(i6.MatBottomSheet), i0.ɵɵinject(i7.MatDialog), i0.ɵɵinject(i8.Router)); }, token: MainService, providedIn: "root" });
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], MainService.prototype, "showError", null);
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], MainService.prototype, "showInformation", null);
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], MainService.prototype, "showWarning", null);
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, material_1.MatDialogConfig]),
        __metadata("design:returntype", Promise)
    ], MainService.prototype, "showDialog", null);
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], MainService.prototype, "showLogin", null);
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], MainService.prototype, "showEnterDialog", null);
    return MainService;
}());
exports.MainService = MainService;
